<template>
  <v-app>
    <v-app-bar color="primary" dark app>
      <v-btn text :to="{ name: 'root' }" exact>Mini Driver Creator</v-btn>
      <v-spacer></v-spacer>
      <v-btn text :to="{ name: 'changelog' }">0.4.1</v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn aria-label="Upload" label="Upload" icon @click="selectFile">
          <input
            ref="fileSelector"
            style="display: none"
            type="file"
            @change="onFilePicked"
          />
          <v-icon>mdi-upload</v-icon>
        </v-btn>
        <v-btn aria-label="Add" label="Add" icon v-on:click.native="addDriver">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <router-view></router-view>
  </v-app>
</template>

<script>
import JSZip from "jszip";

export default {
  name: "App",
  data: () => ({
    fileData: "",
    file: null,
  }),
  methods: {
    addDriver() {
      this.$store.commit("addDriver", {
        id: new Date().getTime(),
      });
    },
    remove(index) {
      this.$store.commit("removeDriver", index);
    },
    selectFile() {
      this.$refs.fileSelector.click();
    },
    onFilePicked(e) {
      const files = e.target.files;

      if (files[0] !== undefined) {
        let zip = JSZip();

        zip.loadAsync(files[0]).then((z) => {
          this.$store.commit("addDriver", {
            id: new Date().getTime(),
            filename: files[0].name,
            zip: z,
          });
        });
      }
    },
  },
};
</script>
